import type { SmartAnalysisTierCounts } from '@/lib/smart-analysis-tiers'

/** Natural-language explanation of tier distribution for employer analysis summary. */
export function smartAnalysisOutcomeExplanation(counts: SmartAnalysisTierCounts): string {
  const total = counts.top + counts.compelling + counts.precluded
  if (total === 0) {
    return 'No candidates were ranked in this run.'
  }

  const parts: string[] = []

  if (counts.top > 0) {
    parts.push(
      `${counts.top} strong ${counts.top === 1 ? 'match is' : 'matches are'} likely interview-ready`,
    )
  }
  if (counts.compelling > 0) {
    parts.push(
      `${counts.compelling} good ${counts.compelling === 1 ? 'match is' : 'matches are'} worth reviewing`,
    )
  }
  if (counts.precluded > 0) {
    parts.push(
      `${counts.precluded} ${counts.precluded === 1 ? 'is' : 'are'} not recommended for this role`,
    )
  }

  if (parts.length === 1) {
    return `${parts[0]}.`
  }
  if (parts.length === 2) {
    return `${parts[0]}; ${parts[1]}.`
  }
  return `${parts[0]}; ${parts[1]}; ${parts[2]}.`
}
